import api from './api';
//tr 12

export type ActivityType =
  | 'login_success'
  | 'login_failed'
  | 'logout'
  | 'patient_created'
  | 'patient_updated'
  | 'patient_finished'
  | 'patient_revived'
  | 'patient_viewed'
  | 'meeting_created'
  | 'meeting_updated'
  | 'meeting_status_changed'
  | 'meeting_viewed'
  | 'meeting_deleted'
  | 'meeting_text_created'
  | 'meeting_text_updated'
  | 'meeting_text_deleted'
  | 'transcript_uploaded'
  | 'recording_uploaded'
  | 'meeting_summarized'
  | 'MEETING_SUMMARY_RUN'
  | 'QUESTIONNAIRE_SUMMARY_RUN'
  | 'user_created'
  | 'user_updated'
  | 'user_deleted'
  | 'other';

export interface ActivityLog {
  id: number;
  user_id: number;
  tenant_id: number;
  activity_type: ActivityType;
  description: string;
  patient_id: number | null;
  meeting_id: number | null;
  created_at: string;
  user_name: string | null;
  patient_name: string | null;
  meeting_title: string | null;
  has_file: boolean;
}

export interface ActivityLogListResponse {
  items: ActivityLog[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export interface ActivityLogFilters {
  page?: number;
  page_size?: number;
  search?: string;
  activity_type?: ActivityType;
  patient_id?: number;
  sort_by?: 'created_at' | 'activity_type' | 'user_name';
  sort_order?: 'asc' | 'desc';
}

export const activityLogService = {
  async getActivityLogs(filters: ActivityLogFilters = {}): Promise<ActivityLogListResponse> {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', filters.page.toString());
    if (filters.page_size) params.append('page_size', filters.page_size.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.activity_type) params.append('activity_type', filters.activity_type);
    if (filters.patient_id) params.append('patient_id', filters.patient_id.toString());
    if (filters.sort_by) params.append('sort_by', filters.sort_by);
    if (filters.sort_order) params.append('sort_order', filters.sort_order);

    const response = await api.get(`/activity-logs/?${params}`);
    return response.data;
  },

  async downloadPromptFile(logId: number): Promise<string> {
    const response = await api.get(`/activity-logs/${logId}/download-prompt`);
    return response.data.download_url;
  },
};
